/**
 * Tiny floating fullscreen button — bottom-right, fades on hover only. Useful
 * for streamers viewing the browser source in a regular browser tab to
 * preview before going live.
 */

export function mountFullscreenButton(): void {
  if (typeof document === 'undefined') return;
  const btn = document.createElement('button');
  btn.textContent = '⛶';
  btn.setAttribute('data-testid', 'an-fullscreen-btn');
  btn.style.cssText = `
    position: fixed; right: 12px; bottom: 12px; z-index: 200;
    background: rgba(0,0,0,0.4); color: #fff;
    border: 1px solid rgba(255,255,255,0.4); border-radius: 6px;
    width: 36px; height: 36px;
    font-size: 20px; cursor: pointer; opacity: 0.3;
    transition: opacity 200ms ease;
  `;
  btn.onmouseenter = () => { btn.style.opacity = '0.95'; };
  btn.onmouseleave = () => { btn.style.opacity = '0.3'; };
  btn.onclick = () => {
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    } else {
      void document.documentElement.requestFullscreen();
    }
  };
  document.body.appendChild(btn);
}
